// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D2Vlvq0","card":"_5D2jcno5"};